
export enum unitTypeEnum {
    C_L = "C-L",
    C_M = "C-M",
    C_S1 = "C-S1",
    C_S2 = "C-S2",
    C_XL = "C-XL",
    C_XS = "C-XS",
    G_L1_R = "G-L1-R",
    G_L2_R = "G-L2-R",
    G_M_R = "G-M-R",
    G_S1_R = "G-S1-R",
    G_S2_R = "G-S2-R",
    G_XL_R = "G-XL-R",
    G_XS_R = "G-XS-R",
    H_L_R = "H-L-R",
    H_L3_R = "H-L3-R",
    H_M1_R = "H-M1-R",
    H_M13_R = "H-M13-R",
    H_M2_R = "H-M2-R",
    H_M23_R = "H-M23-R",
    H_S_R = "H-S-R"
};
